import React from 'react'
import cx from 'classnames'
import styles from './auth-gate.module.scss'
import NewsletterManager from '../newsletter/newsletter-manager'

export default function AuthGate({
  className,
  onComplete,
  interests,
  ...props
}) {
  return (
    <aside className={className}>
      <div className="container container--grid">
        <div className="container__row">
          <div className={styles.content}>
            <div className={cx(styles.content__header, 'child-my-0')}>
              <h2 className="type-p-xml">
                Enter your email to view all case studies and resources, and
                we’ll also keep you informed of new case studies and workshops.
                We’re thoughtful about email frequency and won’t share your
                email with anyone else.
              </h2>
            </div>
            <Input
              interests={interests}
              inputId="dfbi-gate"
              appearance="dfbi-gate"
              onSubscribeComplete={onComplete}
            />
          </div>
        </div>
      </div>
    </aside>
  )
}

function Input({
  inputId,
  label = 'Enter email address',
  placeholder = 'Enter email address',
  appearance = 'default',
  interests = undefined,
  onSubscribeComplete = undefined,
}) {
  const [value, setValue] = React.useState('')

  return (
    <NewsletterManager
      value={value}
      interests={interests}
      onComplete={onSubscribeComplete}
    >
      {({ status, isValid, onSubmit, response }) => (
        <form
          onSubmit={e => {
            e.preventDefault()
            onSubmit({ address: value })
          }}
        >
          <label
            htmlFor={inputId}
            className={cx('newsletter-input', {
              [`newsletter-input--${status}`]: true,
              [`newsletter-input--${appearance}`]: appearance !== 'default',
              'newsletter-input--valid': isValid,
            })}
          >
            <p className="sr-only">{label}</p>
            <div className="newsletter-input__border">
              <div className="position-relative">
                <input
                  required
                  type="email"
                  id={inputId}
                  value={value}
                  placeholder={placeholder}
                  data-invalid={!isValid}
                  className="newsletter-input__field"
                  onChange={e => setValue(e.currentTarget.value)}
                />
                <button
                  type="submit"
                  disabled={!isValid || status === 'busy'}
                  className="newsletter-input__button"
                >
                  <span className="sr-only">Submit</span>
                  <svg
                    width="109"
                    height="92"
                    viewBox="0 0 109 92"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M65.579 1L107.481 45.7345L65.579 90.469L59.7403 85L92.7726 49.7345H1V41.7345H92.7726L59.7403 6.46896L65.579 1Z"
                      fill="#F9CA24"
                      stroke="#000C2D"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </label>
          <div className="newsletter-input__response child-my-0">
            {response ? (
              <p
                aria-live="assertive"
                dangerouslySetInnerHTML={{ __html: response.msg }}
              />
            ) : null}
          </div>
        </form>
      )}
    </NewsletterManager>
  )
}
